import * as React from "react";
import Typography from "@material-ui/core/Typography/Typography";
import FormControl from "@material-ui/core/FormControl/FormControl";
import InputLabel from "@material-ui/core/InputLabel/InputLabel";
import Input from "@material-ui/core/Input/Input";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import IconButton from "@material-ui/core/IconButton/IconButton";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Visibility from "@material-ui/icons/Visibility";
import { Spacer } from "../utility-components";
import Button from "@material-ui/core/Button/Button";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import AccountBox from "@material-ui/icons/AccountBox";
import LockOpen from "@material-ui/icons/LockOpen";
import { NBSP } from "../../utils/string";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Divider, Paper, ExpansionPanel, ExpansionPanelSummary } from "@material-ui/core";
import { BUILD_ID } from "../../build-id";

export interface ILoginFormProps {
    loginAction: (username: string, password: string, onError: (error: any) => void) => void;
    resetAction?: () => void;
}

export interface ILoginFormState {
    error: string | undefined;
    isAuthenticating: boolean;
    username?: string;
    password?: string;
    showPassword: boolean;
}

export class LoginForm extends React.Component<ILoginFormProps, ILoginFormState> {
    constructor(props: ILoginFormProps) {
        super(props);
        this.state = {
            error: undefined,
            isAuthenticating: false,
            showPassword: false
        };
    }
    private handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const { username, password } = this.state;
        if (!username || !password) {
            this.setState({ error: 'Please fill in the form' });
            return;
        }
        this.setState({ error: undefined, isAuthenticating: true });
        this.props.loginAction(username, password, (err: any) => {
            this.setState({ error: 'Bad username or password.', isAuthenticating: false });
        });
    }
    // we only expect field change events on these to field names
    private onFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ error: undefined });
        this.setState({ [e.target.name]: e.target.value } as Pick<ILoginFormState, "password" | "username">);
    }
    private handleMouseDownPassword = (event: React.MouseEvent<HTMLInputElement>) => {
        event.preventDefault();
    }
    private handleClickShowPassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    }
    private onLoginLabourConnectClick = () => {
        window.location.href = '/api/token/labourconnect';
    }

    render(): JSX.Element {
        const { username, password, showPassword, error, isAuthenticating } = this.state;
        const { resetAction } = this.props;

        return <div style={{ alignContent: 'center', maxWidth: '512px', margin: 'auto' }}>
            <form onSubmit={this.handleSubmit}>
                {error &&
                    <Typography className="login-error" variant="h5" gutterBottom color="error">
                        {error}
                    </Typography>
                }

                <Spacer />
                <Spacer />
                <Paper>
                    <>
                    <ExpansionPanel>
                        <ExpansionPanelSummary style={{backgroundColor:'#c2c2c2'}} expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="subtitle1" style={{color:'white'}}>EXTERNAL USERS LOGIN HERE</Typography>
                        </ExpansionPanelSummary>
                        <div style={{padding:'10px'}}>
                        <Spacer />
                        <FormControl fullWidth={true}>
                            <InputLabel htmlFor="inputUsername">Username</InputLabel>
                            <Input id="inputUsername" value={username} name="username" onChange={this.onFieldChange} />
                        </FormControl>
                        <Spacer />
                        <FormControl fullWidth={true}>
                            <InputLabel htmlFor="adornment-password">Password</InputLabel>
                            <Input
                                id="adornment-password"
                                type={showPassword ? 'text' : 'password'}
                                value={password}
                                name="password"
                                fullWidth={true}
                                onChange={this.onFieldChange}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="Toggle password visibility"
                                            onClick={this.handleClickShowPassword}
                                            onMouseDown={this.handleMouseDownPassword}
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                        <Spacer />
                        <Spacer />
                        <Spacer />
                        <Button fullWidth variant="contained" type="submit" className="login-submit" disabled={isAuthenticating} color="primary">
                            {isAuthenticating ? <CircularProgress size={24} /> : <AccountBox />}{NBSP}{isAuthenticating ? "Signing in ..." : "Sign in"}
                        </Button>
                        <Spacer />
                        {resetAction &&
                            <Button fullWidth variant="contained" type="button" className="login-reset-submit" disabled={isAuthenticating} onClick={resetAction} color="default">
                                <LockOpen /> Reset Password</Button>}
                                </div>
                        </ExpansionPanel>
                    </>
                </Paper>

                <Spacer />
                <Spacer />
                <div style={{ width: '100%', height: '11px', borderBottom: '1px solid #e2e2e2', textAlign: 'center' }}>
                    <span style={{ color:'#c2c2c2', fontFamily:'roboto', fontSize: '13px', backgroundColor: '#fff', padding: '0 5px' }}>
                    Or
                    </span>
                </div>
                <Divider />
                <Spacer />
                <Spacer />

                <Button variant="contained" type="button" onClick={this.onLoginLabourConnectClick} className="login-nzlc-submit" fullWidth={true} color="secondary">
                    Labour users login here
            </Button>
            </form>
            <div style={{ float: 'right', margin: '30px' }}>Build ID: <strong>{BUILD_ID}</strong>. Need help? <a href={`mailto:researchhub@labour.org.nz`}>researchhub@labour.org.nz</a></div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/forms/login-form.tsx